module.exports = __webpack_public_path__ + "static/media/Leash_Red_01.1ccf4be4.png";